<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getLevel" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.gradeId" placeholder="级别" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.gradeName" :value="item.gradeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.refundType" placeholder="退款类型" filterable clearable style="width: 200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.refundType)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <!--        <el-select v-model="queryParam.officeId" placeholder="考级点名称" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;">-->
        <!--          <el-option v-for="(item,index) in officeList" :key="index" :label="item.officeName" :value="item.officeId" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.refundTradeNo" clearable placeholder="退款订单号"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-date-picker v-model="queryParam.addTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        value-format="yyyy-MM-ddTHH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="reset" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column prop="refundTradeNo" label="退款订单号"></el-table-column>
        <el-table-column prop="examOrderId" label="报考订单号"></el-table-column>
        <el-table-column prop="examineeName" label="姓名"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号"></el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
<!--        <el-table-column prop="officeName" label="考级点"></el-table-column>-->
        <el-table-column prop="refundType" label="退款类型">
          <template slot-scope="scope">
            {{$enums.refundType[scope.row.refundType]}}
          </template>
        </el-table-column>
        <el-table-column prop="refundFee" label="退款总金额"></el-table-column>
        <el-table-column prop="addTime" label="退款时间"></el-table-column>
        <el-table-column prop="tradeFee" label="订单金额"></el-table-column>
        <el-table-column prop="isImport" label="缴费方式">
          <template slot-scope="scope">
            {{$enums.isImport[scope.row.isImport]}}
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'refund-online',
  components: {},
  props: ['activeName'],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      gradeList: [],
      officeList: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    // this.officeList = await this.$HTTP.ApiOffice.getAgentList()
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {
    activeName (newValue, oldValue) {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['onlinePage'])
    }
  },
  methods: {
    reset () {
      // this.$router.replace({ query: null })
      // window.location.reload()
      this.queryParam = JSON.parse(JSON.stringify(this.oldQueryParam))
      // this.getPage({ pageNum: 1 })
      this.getSpecialtyList()
      this.gradeList = []
    },
    async getLevel (event) {
      if (event) {
        this.queryParam.gradeId = ''
      }
      this.gradeList = await this.$HTTP.ApiSpecialty.getGradeList({ specialtyId: this.queryParam.specialtyId, status: 2 })
      await this.getPage()
    },
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.gradeId = ''
        this.gradeList = []
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        if (this.queryParam.addTime) {
          this.queryParam.startTime = this.queryParam.addTime[0]
          this.queryParam.endTime = this.queryParam.addTime[1]
        }
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiOrderOnline.getPage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    }
  }
}
</script>
